import { KhachHang } from "./customer.model";

export class CTHoaDon {
    HangHoaID: string;
    MaHH: string;
    Stt: number;
    TenHH: string;
    SoLuong: number;
    DGBan: number;
    VATDauRa: number;
    HinhAnh?: boolean;
    ChietKhau?: number;
    LoaiVAT?: number;
    NgayGioQuet?: string;
    SKU?: string;
    Method?: string;
    PriceType?: string;
    //DonViTinh?: string = "EA";
    DGBanCK?: number;
    TienCK?: number;
    TyLeCK?: number;
    TienCKHD = 0;
    TyLeCKHD = 0;;
    checked?: boolean;
    MaNCC: string;
  }

export class HoaDon {
    CTHoaDons: CTHoaDon[];
    HoaDonID: string;
    MaQuay: string;
    MaCH?: string;
    MaKHTV?: string;
    MaHD?: string;
    KHTV?: KhachHang;
    MaNV?: string;
    NgayHD?: Date;
    STTHD?: number;
    LoaiHD?: number;
    TienTraKhach?: number;
    TienCK?: number;
    TongTien: number;
    HDGoc?: string;
    GhiChu?: string;
    TongTienTraHang?: number;
    DaTraHang?: boolean;
    MaCQT?: string;

    constructor(HDs: HoaDon[]) {
        if (HDs === undefined) {
        this.STTHD = 1;
        } else {
        this.STTHD = HDs.length + 1;
        }
    }

    get intoMoney(): string {
        let intoMoney = 0;
        if (this.CTHoaDons) {
        this.CTHoaDons.forEach(arr => {
            intoMoney = (arr.SoLuong * arr.DGBan) + intoMoney;
        });
        const number = FormatSoTien(intoMoney);
        console.log(number);
        return number;
        } else {
        const number = FormatSoTien(intoMoney);
        console.log(number);
        return number;
        }
    }

    // public async printBill(h: string, f: string): Promise<string> {
    //     console.log(await this.intoMoney);
    //     let kqin = '';
    //     kqin += '\t\t\t' + h + '\n';
    //     kqin += '--------------------------------------------------------------------------' + '\n';
    //     kqin += '\n';
    //     kqin += 'Tên sản phẩm' + '\t\t' + 'SL' + '\t\t' + 'Đơn giá' + '\t\t' + 'Chiết khấu';
    //     kqin += '\n';
    //     this.CTHoaDons.forEach(element => {
    //     kqin += element.TenHH + '\t\t' + element.SoLuong + '\t\t' + element.DGBan + '\t\t\t' + element.ChietKhau + '\n';
    //     });
    //     kqin += '\n';
    //     kqin += '--------------------------------------------------------------------------' + '\n';
    //     const s = await this.intoMoney;
    //     kqin += '\t' + 'Thành tiền/Sub total : ' + s + ' VNĐ' + '\n';
    //     kqin += '\t' + 'Giảm giá/Discount : ' + '0' + ' VNĐ' + '\n';
    //     kqin += '\t' + 'Tiền phiếu giảm/Coupon : ' + '0' + ' VNĐ' + '\n';
    //     kqin += '\t\b' + 'Tiền thanh toán : ' + FormatSoTien(this.TongTien) + ' VNĐ' + '\n';
    //     kqin += '\t' + '(Giá trên đã bao gồm 10% VAT)' + '\n';
    //     kqin += '--------------------------------------------------------------------------' + '\n';
    //     kqin += '\t\t\t' + f + '\n';
    //     return kqin;
    // }

    public async printWaitBill(s, tench, tenquay, tennv): Promise<string> {
        let kqin = '<pre>';
        kqin += 'Cửa hàng: ' + tench + '!' + '\n';
        kqin += 'Quầy: ' + tenquay + '\n';
        kqin += 'Nhân viên: ' + tennv + '\n';
        kqin += 'Ngày: ' + s + '\n';
        kqin += '--------------------------------------------------------------------------' + '\n';
        kqin += 'HÓA ĐƠN ĐỢI' + '\n';
        kqin += '\n';
        kqin += '' + 'Hóa đơn đợi số: ' + this.STTHD.toString();
        kqin += '\n';
        kqin += '--------------------------------------------------------------------------' + '\n';
        kqin += '</pre>';
        return await kqin;
    } 
}

export function FormatSoTien(input) {
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function round(num, decimalPlaces = 0) {
  var p = Math.pow(10, decimalPlaces);
  var n = (num * p) * (1 + Number.EPSILON);
  return Math.round(n) / p;
}

export class HTTT {
    MaNhomThanhToan: string;
    MaHinhThuc: string;
    TenHinhThuc: string;
    TenNhom: string;
    DoUuTien: number;
    MaThe?: string;
}

export class ListHD {
    HoaDon: HoaDon;
    TTHD: Array<TTHD>;
}

export class TongThanhToan {
  TenHinhThuc: string;
  SoTienThanhToanHD: number;
}

export class TTHD {
    HTTT: HTTT;
  SoTienThanhToanHD: number;
  TyLeQuyDoi?: number;
  QuyDoiNgoaiTe?: number;
}
export class HTTTs {
    MaNhomThanhToan: string;
    MaHinhThuc: string;
    TenHinhThuc: string;
    TenNhom: string;
    DoUuTien: number;
    MaThe?: string;
    SoTienThanhToanHD: number;
    TyLeQuyDoi?: number;
    QuyDoiNgoaiTe?: number;
}

export class HD {
    CTHoaDon: CTHoaDon[];
    HoaDonId: string;
    MaQuay: string;
    MaKHTV?: string;
    MaHD?: string;
    MaNV?: string;
    MaCH?: string;
    NgayHD?: Date;
    STTHD?: number;
  GhiChu?: string;
    LoaiHD?: number;
    TienTraKhach?: number;
    TongTien: number;
    TongTienCK?: number;
    HTThanhToan?: HTTTs[];
    // --------------- Trí thêm
    HDGoc?: string;
    TongTienTraHang?: number;
    DaTraHang?: boolean;
    MaCQT?: string;
}
export class HDHuy {
    CTHoaDon: CTHoaDon[];
    HoaDonId: string;
    MaQuay: string;
    MaKHTV?: string;
    MaNV?: string;
    NgayHD?: Date;
    STTHD?: number;
    LoaiHD?: number;
    TongTien: number;
}

export class WrapHD {
    Wraped: HD;
}

export class SoHD {
    SoHD: number;
    NgayLapHD: Date;
}

export class VATCount {
    VAT: number;
    count: number;
    SumVAT: number;
}

export const dsVAT: Array<number> = [
    0,
    5,
    10
];



// WEBPACK FOOTER //
// ./src/app/models/bill.model.ts